import React from "react";
import PropTypes from "prop-types";

import { Column, Field, Control, Label, Input } from "rbx";

import { BooleanInput, VendorSelect } from "../inputs";

const VendorForm = ({ inputs, onChange, disabled }) => (
  <div style={{ minWidth: 600 }}>
    <Column.Group>
      <Column>
        <Field>
          <Control>
            <VendorSelect
              orderByNumber
              required
              disabled={disabled}
              label="Vendor"
              name="VendorRecIdRef"
              value={inputs.VendorRecIdRef}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
    </Column.Group>
    <Column.Group>
      <Column size={10}>
        <Field>
          <Control>
            <Label>Vendor Item</Label>
            <Input
              disabled={disabled}
              name="VendorItemNo"
              type="text"
              value={inputs.VendorItemNo}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
      <Column>
        <Field>
          <Control>
            <Label>Primary</Label>
            <BooleanInput
              name="IsPrimary"
              value={inputs.IsPrimary}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
    </Column.Group>
  </div>
);
VendorForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

VendorForm.defaultProps = {
  inputs: {}
};
export default VendorForm;
